import React from 'react';
import { motion } from 'framer-motion';

const Slide13GettingStarted: React.FC = () => {
  const steps = [
    {
      step: '01',
      icon: '📅',
      title: 'Schedule a Demo',
      desc: 'See Lumen8 in action with a personalised walkthrough',
    },
    {
      step: '02',
      icon: '🧪',
      title: 'Pilot Program',
      desc: 'Trial with select classes to see real results',
    },
    {
      step: '03',
      icon: '🚀',
      title: 'Full Deployment',
      desc: 'Seamless onboarding with training and support',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        Getting Started is Easy
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-16 text-center"
      >
        From demo to deployment in three simple steps
      </motion.p>

      <div className="flex items-center gap-6 max-w-5xl">
        {steps.map((item, index) => (
          <React.Fragment key={item.step}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 + index * 0.15 }}
              className="flex-1 rounded-xl p-8 text-center"
              style={{
                background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
              }}
            >
              <div className="text-6xl mb-4">{item.icon}</div>
              <div className="text-sm font-bold text-[#0ea5e9] mb-2">STEP {item.step}</div>
              <h3 className="text-2xl font-semibold text-white mb-3">{item.title}</h3>
              <p className="text-lg text-[#94a3b8]">{item.desc}</p>
            </motion.div>

            {index < steps.length - 1 && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 + index * 0.15 }}
                className="text-4xl text-[#0ea5e9]"
              >
                →
              </motion.div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Slide13GettingStarted;
